import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  CustomDialogProps,
  SmartForm,
  SmartSubmit,
  SmartTextField,
} from "@nodeon/react-components";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";
import { ApiResponse, useOrganizationApi } from "~/api/GeneratedApi";

interface FormProps {
  name: string;
  baseAccess: boolean;
  admin: boolean;
}

interface Props {
  organizationId: number;
  onSubmitted?: () => void;
}

const OrganizationRoleCreationDialog = ({
  handleClose,
  onSubmitted,
  organizationId,
}: CustomDialogProps & Props): JSX.Element => {
  const organizationApi = useOrganizationApi();
  const { t } = useTranslation("organization-role-creation");
  const { enqueueSnackbar } = useSnackbar();

  const onSuccess = (data: FormProps) => {
    enqueueSnackbar(t("created", { role: data.name }), {
      variant: "success",
    });
    onSubmitted?.();
    handleClose?.();
  };

  const onSubmit = (data: FormProps) => {
    return organizationApi.addOrganizationRole(
      {
        roleName: data.name,
        baseAccess: false,
        organizationAdmin: false,
      },
      organizationId,
    );
  };

  return (
    <Dialog open onClose={handleClose} aria-labelledby="form-dialog-title">
      <SmartForm<FormProps, ApiResponse>
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        noGrid
        formProps={{
          defaultValues: { name: "", baseAccess: true, admin: false },
        }}
      >
        <DialogTitle id="form-dialog-title">{t("title")}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SmartTextField<FormProps>
                fullWidth
                name="name"
                label={t("role-name")}
                required
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("general:cancel")}
          </Button>
          <SmartSubmit>{t("general:create")}</SmartSubmit>
        </DialogActions>
      </SmartForm>
    </Dialog>
  );
};

export default OrganizationRoleCreationDialog;
